import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {BerthVisitSelection} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-selection-bunkering-berth-visits',
    templateUrl: './selection-bunkering-berth-visits.component.html',
    styleUrls: ['./selection-bunkering-berth-visits.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectionBunkeringBerthVisitsComponent {

  @Input()
  selection: BerthVisitSelection;

}
